import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';

import authReducers from './auth/reducer';
import walletReducers from './wallet/reducer';
import shopReducers from './shop/reducer';
import reducePaymentReducers from './reduce-payment/reducer';
import advertiseReducers from './advertise/reducer';

const reducers = combineReducers({
  authReducers,
  walletReducers,
  shopReducers,
  reducePaymentReducers,
  advertiseReducers,
  loadingBar: loadingBarReducer
});

export default reducers;
